module.exports = __webpack_public_path__ + "../resources/img/ic_dropdown_check.06f37408.svg";